var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Drag"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Drag_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.50928 3C6.06156 3 6.50928 3.44772 6.50928 4C6.50928 4.55228 6.06156 5 5.50928 5C4.95699 5 4.50928 4.55228 4.50928 4C4.50928 3.44772 4.95699 3 5.50928 3Z",
    fill: "#A6AFCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.50928 7C6.06156 7 6.50928 7.44772 6.50928 8C6.50928 8.55228 6.06156 9 5.50928 9C4.95699 9 4.50928 8.55228 4.50928 8C4.50928 7.44772 4.95699 7 5.50928 7Z",
    fill: "#A6AFCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.50928 12C6.50928 11.4477 6.06156 11 5.50928 11C4.95699 11 4.50928 11.4477 4.50928 12C4.50928 12.5523 4.95699 13 5.50928 13C6.06156 13 6.50928 12.5523 6.50928 12Z",
    fill: "#A6AFCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4905 12C11.4905 11.4477 11.0428 11 10.4905 11C9.93824 11 9.49053 11.4477 9.49053 12C9.49053 12.5523 9.93824 13 10.4905 13C11.0428 13 11.4905 12.5523 11.4905 12Z",
    fill: "#A6AFCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4905 8C11.4905 7.44772 11.0428 7 10.4905 7C9.93824 7 9.49053 7.44772 9.49053 8C9.49053 8.55228 9.93824 9 10.4905 9C11.0428 9 11.4905 8.55228 11.4905 8Z",
    fill: "#A6AFCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4905 4C11.4905 3.44772 11.0428 3 10.4905 3C9.93824 3 9.49053 3.44772 9.49053 4C9.49053 4.55228 9.93824 5 10.4905 5C11.0428 5 11.4905 4.55228 11.4905 4Z",
    fill: "#A6AFCE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrag);
export default __webpack_public_path__ + "static/media/drag.8531375b0adc6859c7fe8994e53c672b.svg";
export { ForwardRef as ReactComponent };